import { VAST, AdPod } from '@lib/iab/iab-vast-model';

import createAd from './ad';
import ErrorHandler from '../errors/error-handler';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

interface ParseOptions {
    strict: boolean;
    noSingleAdPods: boolean;
    errorHandler: ErrorHandler;
}

const triageAds = (
    $$ads: UnmarshalerNode[]
): [UnmarshalerNode[], UnmarshalerNode[]] => {
    const $$adsWithSequence: UnmarshalerNode[] = [];
    const $$adsWithoutSequence: UnmarshalerNode[] = [];
    for (let i = 0; i < $$ads.length; ++i) {
        const $ad = $$ads[i];
        if (typeof $ad.sequence !== 'undefined') {
            $$adsWithSequence.push($ad);
        } else {
            $$adsWithoutSequence.push($ad);
        }
    }
    return [$$adsWithSequence, $$adsWithoutSequence];
};

const createVast = ($vast: UnmarshalerNode, options: ParseOptions): VAST => {
    const vast = new VAST();
    vast.version = $vast.version as number;
    vast.errors.push(
        ...($vast.error as UnmarshalerNode[])
            .map((err: UnmarshalerNode) => err._value as string)
            .filter((uri: string) => uri !== '')
    );

    const [$$adsWithSequence, $$adsWithoutSequence] = triageAds(
        $vast.ad as UnmarshalerNode[]
    );

    if ($$adsWithSequence.length > 0) {
        if (
            options.noSingleAdPods &&
            ($vast.ad as UnmarshalerNode[]).length === 1 &&
            $$adsWithSequence.length === 1
        ) {
            $$adsWithoutSequence.push($$adsWithSequence[0]);
        } else {
            vast.adPod = new AdPod();
            for (let i = 0; i < $$adsWithSequence.length; i++) {
                vast.adPod.ads.add(createAd($$adsWithSequence[i], options));
            }
        }
    }

    for (let i = 0; i < $$adsWithoutSequence.length; i++) {
        vast.ads.add(createAd($$adsWithoutSequence[i], options));
    }

    return vast;
};

export default createVast;
